
// http://stackoverflow.com/questions/28588318/angular-ui-bootstrap-modal-service-using-directive-instead
// answered by Fernando Felix
// enhanced by Websky
// enhanced further by Adam & Mark - 1) Fixed copy/clone of complex JavaScript Objects. 2) Remove jQuery reference for angular 3) Added preModalOpen attribute to allow us to define a angular script to run prior to opening the modal window

/**

@param {redirect-url} String(url value) - Redirecting to a url (Must be used with "on-ok" attribute set to value 'redirect')

*/

(function() {

    var xmsModal = function ($uibModal, timestampUrl) {
        return {
            restrict: 'A',
            scope: true,
            bindToController: {
                xmsModal: '@', // modal view url to render the modal content
                modalController: '@', // modal view controller (optional)
                ngModel: "=",
                openOnLoad: '&',
                disableClose: '<',
                disableBackdropClose: '@', // used to disable only backdrop close
                modalClass: '@',
                onOk: '@',
                onCancel: '@',
                preModalOpen: '@', // code to evaluate before opening a modal (optional)
                labelName: '@', // used to support dynamic button label text
                redirectUrl: '@'
            },
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                // set default controller
                this.$onInit = function(){
                    if( !angular.isDefined(_this.modalController) ){
                        _this.modalController = 'ModalCtrl';
                    }
                }
            }],
            controllerAs: 'ctrl',
            require: 'xmsModal',
            link: function(scope, element, attrs, ctrl){

                element
                    .attr('xms-modal-compiled',attrs.xmsModal)
                    .removeAttr('pre-modal-open')
                    .removeAttr('xms-modal'); // prevents another compilation inside xmsDropdown (tmp fix hopefully) TODO:

                var modalInstance;
                if( ctrl.openOnLoad() ){
                    modalInstance = openModal();
                }

                element.bind('click', function(){

                    // return on disabled link/button
                    if( angular.isDefined(attrs.disabled) && attrs.disabled ) {
                        return;
                    }
                    if(ctrl.preModalOpen) {
                        console.log('preModalOpen', ctrl.preModalOpen);
                        scope.$eval(ctrl.preModalOpen);
                    }
                    modalInstance = openModal();

                    /*modalInstance.opened.then(
                        function(){
                            alert('opened!');
                        },
                        function(){
                            alert('content failed!');
                        }
                    );*/

                    modalInstance.result.then(
                        function (returnValue) {
                            // alert('value: '+returnValue);
                            console.log('modal returnValue:');
                            console.log(returnValue);

                            if(!angular.isDefined(ctrl.ngModel)) {
                                console.log("xms-modal: ngModel is undefined, cannot copy, assigning reference instead");
                                ctrl.ngModel = returnValue;
                            } else {
                                angular.copy(returnValue,ctrl.ngModel);
                            }

                            if( angular.isDefined(ctrl.onOk) ){
                                if(ctrl.onOk == 'redirect'){
                                    redirect(ctrl.redirectUrl);
                                }else {
                                    scope.$eval(ctrl.onOk);
                                }
                            }
                        }, function () {
                            console.log('Modal dismissed at: ' + new Date());
                            if( angular.isDefined(ctrl.onCancel) ){
                                scope.$eval(ctrl.onCancel);
                            }
                        }
                    );

                });

                function redirect(url){
                    window.location.href = url;
                }

                function openModal(){
                    var modalPath = ctrl.xmsModal;

                    var backdrop = ctrl.disableClose || ctrl.disableBackdropClose ? 'static' : true;
                    var keyboard = ctrl.disableClose ? false : true;
                    var modalClass = angular.isDefined(ctrl.modalClass) ? ctrl.modalClass : '';

                    if(modalPath.indexOf(WEBAPP_PATH) == -1 && modalPath.indexOf("/") != -1) {
                        if(modalPath.indexOf("modal/")==-1){ // skip all the templates inside modal folder (TODO: need better solution for that!)
                            modalPath = WEBAPP_PATH + modalPath;
                        }
                    }
                    if(modalPath.indexOf(".html") == -1){
                        // it needs timestamp hash, otherwise the modal gets the data from the cache (probably through ng-init)
                        modalPath = timestampUrl.add(modalPath); // ((modalPath.indexOf('?') == -1) ? '?' : '&') + 'modal_load_hashtag=' + Date.now();
                    }
                    var templateArr = []
                        templateArr = [
                            '<div class="modal-body '+ modalClass +'">',
                            '<button ng-click="cancel()" type="button" class="close" aria-label="Close">',
                            ctrl.disableClose ? '' : '<span aria-hidden="true">&times;</span>',
                            '</button>',
                            '<i ng-show="!loaded" ng-init="loaded=false" class="modal-spinner loading-spinner"></i>',
                            '<div ng-include="\'' + modalPath + '\'" onload="loaded=true"></div>',
                            '</div>'
                        ];
                    var template = templateArr.join('');


                    // see modal reference from ui bootstrap at <http://angular-ui.github.io>
                    // if(typeof scope.modalController !== "undefined" && scope.modalController != "" ) {
                        // if controller declared
                        var modalInstance = $uibModal.open({
                            // scope: scope,
                            size: attrs.size,
                            animation: true,
                            template: template,
                            backdrop: backdrop,
                            keyboard:keyboard,
                            resolve: {
                                params: function () {
                                    console.log('value passed to modal:');
                                    console.log(ctrl.ngModel);

                                    // if it's an object we need to create object copy!!!!!
                                    if( angular.isObject(ctrl.ngModel) ){
                                        return angular.copy(ctrl.ngModel);
                                    } else {
                                        return ctrl.ngModel;
                                    }

                                    //return ctrl.ngModel;
                                }
                            },
                            controller: ctrl.modalController
                        });
                    /*} else {
                        // no controller (very simple modal)
                        modalInstance = $uibModal.open({
                            size: attrs.size,
                            animation: true,
                            template: template
                        });
                    }*/
                    return modalInstance;
                }


            }
        };
    }
    xmsModal.$inject = ['$uibModal', 'timestampUrl'];
    angular.module('app').directive('xmsModal', xmsModal);





/* this is quite generic controller which can be used in most of the cases */
/* you can use this code to create your custom controller and pass it with modal-controller to xms-modal */
var ModalCtrl = function (helperFactory, $scope, $uibModalInstance, passedModel) {

    $scope.angularHelper    = helperFactory;

    // $uibModalInstance: same from ui bootstrap
    // passedModel is the modal ng-model passed via directive (object copy)
    if( !angular.isDefined(passedModel) ){
        passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
    }

    console.log('ModalCtrl init!');
    // your code
    $scope.ngModel = passedModel; // whatever you need to use in the template - you may name your template model ngModel
    // $scope.formModel = passedModel; // or formModel - just mind it will be different formModel than rest of the page (just name share)

    $scope.ok = function() {
        $uibModalInstance.close(this.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)
    };
    $scope.cancel = function(e) {
        if(angular.isDefined(e)){
            e.preventDefault();
        }
        $uibModalInstance.dismiss('cancel');
    };


    // duplicated from app.js as modal window doesn't have the access to the main scope
    // TODO: move to the config
    // TODO: this should now work with the main ocLoadModal as modal has been rewritten to inherited scope
    $scope.ocLoadModal = {
        ckeditor: {
            name:'ngCkeditor', files:[
            WEBAPP_PATH + '/js/vendor/angular/ng-ckeditor/ng-ckeditor.js',
            WEBAPP_PATH + '/js/vendor/CKEditor/ckeditor.js'
        ]}
    };
}
ModalCtrl.$inject = ['helperFactory', '$scope', '$uibModalInstance', 'params'];
angular.module('app').controller('ModalCtrl',ModalCtrl);


// the controller will submit main form on OK/Submit
// you may want to use it for "Are you sure to continue?" modal
var SubmitMainFormCtrl = function ($scope, $uibModalInstance, $timeout) {
    $scope.isDisabled = false;
    $scope.ok = function() {
        $timeout(function(){
             $scope.isDisabled = true;
            $('.main').find('form').submit();
        });
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}
SubmitMainFormCtrl.$inject = ['$scope', '$uibModalInstance', '$timeout'];
angular.module('app').controller('SubmitMainFormCtrl', SubmitMainFormCtrl);


}());
